import './carinha.css';

interface CarinhaProps {
  image?: string;
  name: string;
}

const Carinha: React.FC<CarinhaProps> = ({ name, image }) => {
  return (
    <div>
      {!!image && (
        <img className='big-face' alt={name} src={image} />
      )}
      <p>{name}</p>
    </div>
  );
}

export default Carinha;
